import {
  PriceCalendarResponseItem,
  PriceType
} from "@website/accommodation-ui/price-calendar-wrapper/types";

export const getStayCount = (dateToString: string, dateFromString: string) => {
  const dateTo = new Date(dateToString).getTime();
  const dateFrom = new Date(dateFromString).getTime();
  const diffDays = Math.abs(dateTo - dateFrom);
  return Math.floor(diffDays / (1000 * 60 * 60 * 24));
};

export const createLink = (item: PriceCalendarResponseItem, query: any) => ({
  pathname: "/[origin]/[dest]",
  query: {
    ...query,
    stDate: item?.departureDate.toString(),
    rtDate: item?.returnDate.toString()
  }
});

export const getPriceStatus = (
  item: PriceCalendarResponseItem,
  highestPrice: number | undefined,
  lowestPrice: number | undefined
): PriceType => {
  if (item.minPrice === highestPrice) return "worstPrice";
  if (item.minPrice === lowestPrice) return "bestPrice";
  return "normal";
};
